import cls from "./profileHeader.module.scss";
import ArrowLeftSLineIcon from "remixicon-react/ArrowLeftSLineIcon";
import ArrowRightSLineIcon from "remixicon-react/ArrowRightSLineIcon";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import dynamic from "next/dynamic";
import { useAuth } from "contexts/auth/auth.context";
import { useTheme } from "contexts/theme/theme.context";
import { BrandLogo, BrandLogoDark } from "components/icons";
import Link from "next/link";
import React from "react";
import { useMediaQuery } from "@mui/material";
import Image from "next/image";
import { profileDropdownLinks } from "components/profileDropdown/profileDropdownLinks";
import useModal from "hooks/useModal";

const ProfileDropdown = dynamic(
  () => import("components/profileDropdown/profileDropdown"),
);
const Sidebar = dynamic(() => import("containers/sidebar/sidebar"));
const DrawerContainer = dynamic(() => import("containers/drawer/drawer"));

export default function ProfileHeader() {
  const { t } = useTranslation();
  const { pathname, back, push } = useRouter();
  const { user, isAuthenticated, openAuthModal } = useAuth();
  const { direction, isDarkMode } = useTheme();
  const isDesktop = useMediaQuery("(min-width:1024px)");

  const [open, handleOpen, handleClose] = useModal();

  const handleBack = () => {
    if (pathname.includes("orders")) {
      push("/orders");
      return;
    }
    if (pathname.includes("checkout")) {
      back();
      return;
    }
    push("/");
  };

  return (
    <>
      <div className={cls.container}>
        <header className={`container ${cls.header}`}>
          {isDesktop ? (
            <button className={cls.backBtn} onClick={handleBack}>
              {direction === "rtl" ? (
                <ArrowRightSLineIcon />
              ) : (
                <ArrowLeftSLineIcon />
              )}
              <span className={cls.text}>{t("back")}</span>
            </button>
          ) : (
            <button className={cls.backBtn} onClick={handleOpen}>
              <Image src="/images/menu.svg" alt="menu" width={20} height={20} />
            </button>
          )}
          <Link href="/">{isDarkMode ? <BrandLogoDark /> : <BrandLogo />}</Link>
          {isAuthenticated ? (
            <ProfileDropdown data={user} />
          ) : (
            <button type="button" onClick={openAuthModal} className={cls.login}>
              {t("login")}
            </button>
          )}
        </header>
      </div>
      <DrawerContainer
        open={open}
        onClose={handleClose}
        anchor="left"
        PaperProps={{
          style: {
            width: "350px",
          },
        }}
      >
        <Sidebar withLinks onClose={handleClose} />
      </DrawerContainer>
    </>
  );
}
